import { useTimeline } from '../../state/timeline';

// project settings (nothing selected)

const SIZE_PRESETS = [
  { label: '1280 × 720', w: 1280, h: 720 },
  { label: '1920 × 1080', w: 1920, h: 1080 },
  { label: '854 × 480', w: 854, h: 480 },
];

export default function ProjectSettings() {
  const settings = useTimeline((s) => s.edit.settings);
  const setSettings = useTimeline((s) => s.setSettings);
  return (
    <div className="insp-section">
      <h3>Project settings</h3>
      <label className="insp-field">
        <span>frame size</span>
        <select
          value={`${settings.width}x${settings.height}`}
          onChange={(e) => {
            const p = SIZE_PRESETS.find((x) => `${x.w}x${x.h}` === e.target.value);
            if (p) setSettings({ width: p.w, height: p.h });
          }}
        >
          {SIZE_PRESETS.map((p) => (
            <option key={p.label} value={`${p.w}x${p.h}`}>
              {p.label}
            </option>
          ))}
          {!SIZE_PRESETS.some((p) => p.w === settings.width && p.h === settings.height) && (
            <option value={`${settings.width}x${settings.height}`}>
              {settings.width} × {settings.height}
            </option>
          )}
        </select>
      </label>
      <label className="insp-field">
        <span>fps</span>
        <select
          value={settings.fps}
          onChange={(e) => setSettings({ fps: parseInt(e.target.value, 10) })}
        >
          {[24, 25, 30].map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </select>
      </label>
      <label className="insp-field">
        <span>background</span>
        <input
          type="color"
          value={settings.background}
          onChange={(e) => setSettings({ background: e.target.value })}
        />
      </label>
      <p className="insp-hint">Select a clip to edit its properties.</p>
    </div>
  );
}
